<template>
	<v-layout
		row
		wrap
		justify-center
	>
		<v-flex xl8>
			<v-data-iterator
				ref="iterator"
				:items="items"
				:pagination.sync="pagination"
				:search="search"
				:rows-per-page-items="rowsPerPageItems"
				:custom-filter="filterItems"
				:custom-sort="customSort"
				no-data-text="No projects available"
				no-results-text="No matching projects found"
				content-tag="v-layout"
				row
				wrap
			>
				<template slot="header">
					<IteratorToolbar
						:sort-by="sortBy"
						:sort-name="sortName"
						:pagination="pagination"
						:initial-view="changeView"
						@search="search = $event"
						@change-view="changeView = $event"
						@sort="sort"
						@pagination="changeSortDirection"
					/>
				</template>
				<ProjectListAndCard
					slot="item"
					slot-scope="props"
					:project="props.item"
					:card-type="changeView"
					@edit="$emit('edit', $event)"
					@archive="$emit('archive', $event)"
				/>
			</v-data-iterator>
		</v-flex>
	</v-layout>
</template>

<script>
import IteratorMixin from '@/mixins/IteratorMixin';
import IteratorToolbar from '@/components/IteratorToolbar';
import ProjectListAndCard from '@/components/Project/ProjectListAndCard';

export default {
	components: {
		IteratorToolbar,
		ProjectListAndCard,
	},
	mixins: [IteratorMixin],
	props: {
		items: { type: Array, default: null },
	},
	data() {
		return {
			sortBy: [
				{ name: 'Last Active', value: 'lastActive' },
				{ name: 'Date Added', value: 'id' },
				{ name: 'Name', value: 'name' },
			],
			cardStyle: 'cardStyle_projects',
			sortStorage: 'sort_projects',
		};
	},
};
</script>
